import { render, staticRenderFns } from "./manger.vue?vue&type=template&id=1a858244&scoped=true"
import script from "./manger.vue?vue&type=script&lang=js"
export * from "./manger.vue?vue&type=script&lang=js"
import style0 from "./manger.vue?vue&type=style&index=0&id=1a858244&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a858244",
  null
  
)

export default component.exports